export enum LOCALSTORAGE_CUSTOM_ROUTES_PAGE {
  'checkout-cancel' = 'checkout',
  'checkout-error' = 'checkout',
}
